import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

export default function withScrollToTop(WrappedComponent) {

  class ScrollToTop extends Component {
    static displayName = `withScrollToTop(${WrappedComponent.displayName || WrappedComponent.name})`;

    componentDidUpdate(prevProps) {

      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }

    render() {
      return <WrappedComponent { ...this.props } />;
    }
  }

  return withRouter(ScrollToTop);
}



// WEBPACK FOOTER //
// ./src/hoc/withScrollToTop.jsx